import { Card, Header } from "semantic-ui-react";

import React from "react";

import Flex from "../../../../../components/Flex/Flex";
import useDistributionPipelineDropdownMenuOptions from "../../../../distribution/hooks/useDistributionPipelineDropdownMenuOptions";
import DropdownMenu from "../../../../ui/components/DropdownMenu/DropdownMenu";

export default function SuperAdminDistributionPipelineHeader({ channel, pipeline }) {
	const dropdownMenuOptions = useDistributionPipelineDropdownMenuOptions({ channel });

	return (
		<Card fluid>
			<Card.Content>
				<Flex gap={15}>
					<Flex justifyContent="flex-start" gap={10}>
						<Header style={{ margin: 0 }}>{pipeline.name}</Header>
					</Flex>

					<DropdownMenu options={dropdownMenuOptions(pipeline)} />
				</Flex>
			</Card.Content>
		</Card>
	);
}
